export const Clock = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.6665 4.375L4.1665 1.875M18.3332 4.375L15.8332 1.875M9.99984 6.66667V10L12.0832 12.0833M17.7082 10C17.7082 14.2572 14.257 17.7083 9.99984 17.7083C5.74264 17.7083 2.2915 14.2572 2.2915 10C2.2915 5.74281 5.74264 2.29167 9.99984 2.29167C14.257 2.29167 17.7082 5.74281 17.7082 10Z"
      stroke={"#D71313"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Clock
